import IndustryIndex from "../views/Enterprise/IndustryIndex.vue";
import ProductIndex from "../views/Enterprise/ProductIndex.vue";
import EnterpriseIndex from "../views/Enterprise/Index.vue";
import DigitalIndex from "../views/Enterprise/DigitalIndex.vue";
import IndustryClassify from "@/zh-website/src/views/Enterprise/components/IndustryClassify.vue";
import ProductClassify from "@/zh-website/src/views/Enterprise/components/ProductClassify.vue";
import DigitalClassify from "@/zh-website/src/views/Enterprise/components/DigitalClassify.vue";
import CommonSolution from "@/zh-website/src/views/Enterprise/components/solution/CommonSolution.vue";
import ProductSolution from "@/zh-website/src/views/Enterprise/components/solution/ProductSolution.vue";
import CommonCase from "@/zh-website/src/views/Enterprise/components/case/CommonCase.vue";
import AllSuccessCase from "@/zh-website/src/views/Enterprise/components/AllSuccessCase.vue";
import SuccessCaseDetail from "@/zh-website/src/views/Enterprise/components/all-success-case/SuccessCaseDetail.vue";
import Autnent from "@/zh-website/src/views/Enterprise/Autnent.vue";
export const EnterpriseRoute = {
  path: "/enterprise",
  name: "Enterprise",
  component: EnterpriseIndex,
  meta: { type: 2, title: "政企用户-浙江华为门户网站", serial: 1 },
  redirect: "/enterprise/page",
  children: [
    //行业人才发展 包括 主页、分类详情页、解决方案页、成功案例页
    {
      path: "/enterprise/page",
      name: "Index",
      component: IndustryIndex,
      meta: {
        type: 2,
        title: "政企用户-浙江华为门户网站",
        serial: 1
      }
    },
    {
      path: "/enterprise/industry/classify/:id",
      name: "classify",
      component: IndustryClassify,
      meta: {
        type: 2,
        serial: 1
      }
    },
    {
      path: "/enterprise/industry/solution/:id",
      name: "solution",
      component: CommonSolution,
      meta: {
        type: 2,
        title: "解决方案-浙江华为门户网站",
        serial: 1
      }
    },
    {
      path: "/enterprise/industry/case/:id",
      name: "case",
      component: CommonCase,
      meta: {
        type: 2,
        title: "成功案例-浙江华为门户网站",
        serial: 1
      }
    },
    //产品技术培训 包括 主页、分类详情页、解决方案页、成功案例页
    {
      path: "/enterprise/product/page",
      name: "Technical",
      meta: {
        type: 2,
        title: "产品技术培训-浙江华为门户网站",
        serial: 2
      },
      component: ProductIndex
    },
    {
      path: "/enterprise/product/classify/:id",
      name: "classify",
      component: ProductClassify,
      meta: {
        type: 2,
        serial: 2
      }
    },
    {
      path: "/enterprise/product/solution/:id",
      name: "solution",
      component: ProductSolution,
      meta: {
        type: 2,
        title: "解决方案-浙江华为门户网站",
        serial: 2
      }
    },
    {
      path: "/enterprise/product/case/:id",
      name: "case",
      component: CommonCase,
      meta: {
        type: 2,
        title: "成功案例-浙江华为门户网站",
        serial: 2
      }
    },
    //数字化领导力培训 包括 主页、分类详情页、解决方案页、成功案例页
    {
      path: "/enterprise/digital/page",
      name: "Technical",
      meta: {
        type: 2,
        title: "数字化领导力-浙江华为门户网站",
        serial: 3
      },
      component: DigitalIndex
    },
    {
      path: "/enterprise/digital/classify/:id",
      name: "classify",
      component: DigitalClassify,
      meta: {
        type: 2,
        serial: 3
      }
    },
    {
      path: "/enterprise/digital/solution/:id",
      name: "solution",
      component: CommonSolution,
      meta: {
        type: 2,
        title: "解决方案-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/enterprise/digital/case/:id",
      name: "case",
      component: CommonCase,
      meta: {
        type: 2,
        title: "成功案例-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/enterprise/all-success-case",
      name: "AllSuccessCase",
      component: AllSuccessCase,
      meta: {
        type: 2,
        title: "综合案例-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/enterprise/all-success-case/detail/:id",
      name: "AllSuccessCaseDetail",
      component: SuccessCaseDetail,
      meta: {
        type: 2,
        title: "案例详情-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/enterprise/digital/all-success-case/detail/:id",
      name: "AllSuccessCaseDetail",
      component: SuccessCaseDetail,
      meta: {
        type: 2,
        title: "案例详情-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/enterprise/product/all-success-case/detail/:id",
      name: "AllSuccessCaseDetail",
      component: SuccessCaseDetail,
      meta: {
        type: 2,
        title: "案例详情-浙江华为门户网站",
        serial: 4
      }
    },
    // {
    //   path: "/enterprise/comprehensive/datail",
    //   name: "Authent",
    //   component: resolve => require(["@/components/Enterprise/Case"], resolve),
    //   meta: {
    //     type: 2,
    //     title: "案例详情-浙江华为门户网站",
    //     serial: 4
    //   }
    // },
    {
      path: "/enterprise/authent/:id",
      name: "Authent",
      component: Autnent,
      meta: {
        type: 2,
        title: "华为认证-浙江华为门户网站",
        serial: 5
      }
    }
  ]
};
